<template>
  <campaigns-list status="past" />
</template>

<script>
import CampaignsList from '@/modules/campaigns/components/CampaignsList'
export default {
  name: 'PastCampaignsTab',
  components: { CampaignsList }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/campaigns/components/PastCampaignsTab.vue